import $ from 'jquery';

export const init = () => {
	const initContacts = () => {
		$('a[href^="tel:"]').each(function () {
			let phone = $(this).text();
			let desc = getDesc($(this));
			if ($(this)) {
				$(this).on('click auxclick', function (e) {
					// On left and middle mouse button.
					if (e.which === 1 || e.which === 2) {
						let data = {
							event: 'contactClick',
							contactType: 'Phone',
							contactDescription: desc,
							contactLinkText: phone,
						};
						dataLayer.push(data);
					}
				});
			}
		});
		$('a[href^="mailto:"]').each(function () {
			let email = $(this).text();
			let desc = getDesc($(this));
			if ($(this)) {
				$(this).on('click auxclick', function (e) {
					// On left and middle mouse button.
					if (e.which === 1 || e.which === 2) {
						let data = {
							event: 'contactClick',
							contactType: 'Email',
							contactDescription: desc,
							contactLinkText: email,
						};
						dataLayer.push(data);
					}
				});
			}
		});
	};

	const initDownloadDocuments = () => {
		$('li[class="documents__list-item"]').each(function () {
			$(this).on('click auxclick', function (e) {
				if (e.which === 1 || e.which === 2) {
					let data = {
						event: 'fileDownload',
						fileName: $.trim($(this).text()),
					};
					dataLayer.push(data);
				}
			});
		});
	};

	const initDownloadThemes = () => {
		$('li[id^="download-theme-file-"]').each(function () {
			let $link = $(this).find('a:first');
			let text = $link.find('.item-icon__text').text();
			$link.on('click auxclick', function (e) {
				let data = {
					event: 'fileDownload',
					fileName: text,
				};
				dataLayer.push(data);
			});
		});
	};

	const initDownloadButtons = () => {
		$('a[id^="download-button-file-"]').each(function () {
			$(this).on('click auxclick', function (e) {
				if (e.which === 1 || e.which === 2) {
					let data = {
						event: 'fileDownload',
						fileName: $.trim($(this, '.button__text').text()),
					};
					dataLayer.push(data);
				}
			});
		});
	};

	const initCTALinks = () => {
		let links = $('a[id^="cta-"][href]:not([href^="#"]), button[id^="cta-"][href]:not([href^="#"]), input[type="submit"][id^="cta-"]');
		links.each(function () {
			$(this).on('click auxclick', function (e) {
				if (e.which === 1 || e.which === 2) {
					let ctaPosition;
					let ctaDest;
					if ($(this).parents('form').length > 0) {
						ctaPosition = 'form';
					} else if ($(this).parents('main').length > 0) {
						ctaPosition = 'main';
					} else if ($(this).parents('header').length > 0) {
						ctaPosition = 'header';
					} else if ($(this).parents('footer').length > 0) {
						ctaPosition = 'footer';
					}
					if (ctaPosition != 'form') {
						ctaDest = $(this).attr('href');
					} else {
						ctaDest = $(this).attr('formaction');
						if (!ctaDest) {
							ctaDest = $(this).attr('data-url');
						}
					}
					let data = {
						event: 'ctaClick',
						ctaPosition: ctaPosition,
						ctaDestination: ctaDest,
						ctaID: $(this).attr('id'),
						ctaClass: $(this).attr('class'),
						ctaText: $.trim($(this).text()),
					};
					dataLayer.push(data);
				}
			});
		});

		// Kentico Form redirect submits
		const params = window.location.search.substring(1).split('&');
		const prefix = 'DLCTA';
		let data = {};
		let newParams = window.location.search.substring(1);
		params.forEach(function (item) {
			if (item.startsWith(prefix)) {
				let [key, value] = item.split('=');
				data[key.replace(prefix, '')] = value;
				newParams = newParams.replace(item + '&', '');
				newParams = newParams.replace(item, '');
			}
		});
		if (Object.keys(data).length > 0) {
			data['event'] = 'ctaClick';
			data['ctaPosition'] = 'form';
			data['ctaDestination'] = window.location.origin + window.location.pathname;
			dataLayer.push(data);

			// Remove parameters so dL is not sent again.
			if (newParams) {
				if (newParams.endsWith('&')) {
					newParams = newParams.substring(0, newParams.length - 1);
				}
				window.history.replaceState(null, null, window.location.pathname + '?' + newParams + window.location.hash);
			} else {
				window.history.replaceState(null, null, window.location.pathname + window.location.hash);
			}
		}
	};

	// Try to get header/description text for given field from parent or grandparent by part of its class.
	const getDesc = (element) => {
		let desc = element.parent().find('[class*="title"]:first, [class*="name"]:first').text();
		if (!desc) {
			desc = element.parent().parent().find('[class*="title"]:first, [class*="name"]:first').text();
		}
		return desc;
	};

	initContacts();
	initDownloadDocuments();
	initDownloadThemes();
	initDownloadButtons();
	initCTALinks();
};
